import React from "react";
import styled from "styled-components"
import Pl from "./../../assets/images/svg/pl.svg"
import Us from "./../../assets/images/svg/us.svg"
import { HREFLANGS } from "../../utils/seoUrls"
import SiteLanguage from "../../helpers/siteLanguage"
import { VisuallyHidden } from "../global/common/essentials"

const Link = styled.a`
  width: 30px;
  height: 30px;
`

const LanguageSwitcherContainer = styled.div`
  display: flex;
  gap: 2rem;

  svg {
    width: 100%;
    height: 100%;
    transition: all 200ms ease;
  
    &:hover {
      transform: rotate(20deg);
    }
  }
`

const LanguageSwitcher = ({ pageContext }) => {
  const isPolish = SiteLanguage() === "pl"

  const translation = pageContext?.alternates?.find(
    ({ hreflang }) => hreflang === (isPolish ? HREFLANGS.en : HREFLANGS.pl)
  )
  const fallbackUrl = pageContext?.contentType === 'post'
    ? (isPolish ? 'https://bravenew.agency/blog/' : 'https://bravenew.agency/pl/wpisy/')
    : (isPolish ? 'https://bravenew.agency/' : 'https://bravenew.agency/pl/')

  return (
    <LanguageSwitcherContainer>
      {/* Only a flag shows; the hidden text names it in its target language. */}
      <Link
        href={translation ? translation.href : fallbackUrl}
        hrefLang={isPolish ? "en" : "pl"}
        lang={isPolish ? "en" : "pl"}
      >
        {isPolish ? <Us aria-hidden="true" /> : <Pl aria-hidden="true" />}
        <VisuallyHidden>{isPolish ? "English version" : "Polska wersja"}</VisuallyHidden>
      </Link>
    </LanguageSwitcherContainer>
  );
};

export default LanguageSwitcher;